const FORCE_VARIANT_PARAM = 'variant';

export class PersonalizeService {
  /**
   * @param {Object} sdk
   * @param {string} uid
   * @param {string} search
   * @param {Object} personalizedData
   * @returns {Promise<{alias: string, data: *}|null>}
   */
  static async fetchPersonalizeData(sdk, uid, search, personalizedData) {
    if (!personalizedData) {
      return null;
    }
    const personalizeVariant = sdk.getVariantAliases().find((alias) => personalizedData[alias] !== undefined);
    const variant = PersonalizeService.getForcedVariant(personalizeVariant, search) || personalizeVariant;
    const activeVariantData = personalizedData[variant];

    if (!activeVariantData) {
      return null;
    }

    return {
      alias: variant,
      data: activeVariantData,
    };
  }

  /**
   * In case there is a URL parameter `variant`, it will override the active variant with the value of that parameter.
   * @param activeVariant
   * @param search
   * @returns {string|undefined}
   */
  static getForcedVariant(activeVariant, search) {
    const params = new URLSearchParams(search || '');
    const forcedVariant = params.get(FORCE_VARIANT_PARAM);
    if (!forcedVariant) return;

    const aliasWithoutVariant = activeVariant.replace(/(\d+)$/, ''); // Remove numeric suffix (active variant number)

    return `${aliasWithoutVariant}${forcedVariant}`;
  }
}
